import React from 'react';
import { connect } from 'react-redux';
import { PatientCareCenterNoteSection } from 'PatientCareCenter/Note';
import {
    PatientCareCenterNoteSubjectiveHistory,
    PatientCareCenterNoteSubjectiveWorkComp,
    PatientCareCenterNoteSubjectivePain,
    PatientCareCenterNoteSubjectiveEquip,
    PatientCareCenterNoteSubjectivePTEquip,
    PatientCareCenterNoteSubjectiveMeds,
    PatientCareCenterNoteSubjectiveHeadaches,
    PatientCareCenterNoteSubjectiveDepress,
    PatientCareCenterNoteSubjectiveSeverity,
    PatientCareCenterNoteSubjectiveMotivation,
    PatientCareCenterNoteSubjectiveFitness,
    PatientCareCenterNoteSubjectivePhase,
    PatientCareCenterNoteSubjectiveNonEval,
    PatientCareCenterNoteSubjectiveSleep
} from 'PatientCareCenter/Note/Subjective';


class PatientCareCenterNoteSubjective extends React.Component {

    render() {
        return (
            <PatientCareCenterNoteSection id='subjective' name='Subjective' refProp={this.props.refProp}>
                {this.props.noteType === 1 &&
                    <span>
                        <PatientCareCenterNoteSubjectiveHistory />
                        <PatientCareCenterNoteSubjectiveWorkComp />
                        <PatientCareCenterNoteSubjectivePain />
                        {(!this.props.isPeds || !this.props.isPedsEnabled) &&
                            <PatientCareCenterNoteSubjectiveMeds />
                        }
                        <PatientCareCenterNoteSubjectiveSeverity />
                        <PatientCareCenterNoteSubjectiveMotivation />
                        <PatientCareCenterNoteSubjectiveFitness />
                        <PatientCareCenterNoteSubjectivePhase />
                        <PatientCareCenterNoteSubjectiveDepress />
                        <PatientCareCenterNoteSubjectiveHeadaches />
                        {(this.props.isPeds || this.props.isPedsEnabled || this.props.isPedsSpeech) &&
                        <PatientCareCenterNoteSubjectiveEquip />
                        }
                        {(!this.props.isPeds || !this.props.isPedsEnabled) &&
                            <PatientCareCenterNoteSubjectiveSleep />
                        }
                    </span>
                }
               
                {this.props.noteType !== 1 &&
                <span>

                    <PatientCareCenterNoteSubjectiveNonEval />
                    {(this.props.isPeds || this.props.isPedsEnabled || this.props.isPedsSpeech) &&
                        <PatientCareCenterNoteSubjectivePTEquip />
                    }
                 </span>
                }
            </PatientCareCenterNoteSection>
        );
    }

}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let epno = noteType === 1 ? state.entities.notes.PTEVAL[pk].EVEPNO : state.entities.notes.PTNOTE[pk].NTEPNO;
    let isPeds = state.entities.admissions[epno].isPeds;
    let isPedsEnabled = state.entities.masterData.PROPS ? state.entities.masterData.PROPS['PTERO_PEDS_ENABLED'].PRVALUE === 'true' : false;
    let isPedsSpeech = state.entities.admissions[epno].isPedsSpeech;
    return {
        isPedsSpeech,
        noteType,
        isPeds,
        isPedsEnabled,

    };
}

const connectedPatientCareCenterNoteSubjective = connect(mapStateToProps)(PatientCareCenterNoteSubjective);
export { connectedPatientCareCenterNoteSubjective as PatientCareCenterNoteSubjective };

